import React from "react";
import { Box } from "@mui/material";

import Footer from "./sections/Footer";

import Header from "./Header";
import WelcomeBox from "./components/WelcomeBox";
import SectionsGrid from "./components/SectionsGrid";




function Home() {
    return (
        <div>

            <Header />
        <Box
            sx={{
                // height: "100vh",
                // overflowY: "scroll",
                // scrollSnapType: "y mandatory",
                overflowX: "hidden",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" },
                p: 1
            }}
        >

            <WelcomeBox />
            <SectionsGrid />



        </Box>
            <Footer />
        </div>
    );
}

export default Home;